const updateStreams = (filterData: any, filterOptions: any) => {
  //   const filterVariable =  filterOptions.country?.country_url === "study-in-india" ?

  let filteredColleges;
  if (filterOptions.country?.country_url === 'study-in-india') {
    filteredColleges = filterData.filter((college: any) => college.country?.country_url === 'study-in-india');
  } else {
    filteredColleges = filterData.filter((college: any) => college.country?.country_url !== 'study-in-india');
  }

  const streams = filteredColleges?.flatMap((college: any) => college?.streams);

  const uniqueStreams: any[] = [];
  const streamIds = new Set();

  streams?.forEach((stream: any) => {
    if (!streamIds.has(stream.id)) {
      streamIds.add(stream.id);
      uniqueStreams.push(stream);
    }
  });

  return uniqueStreams;
};

export default updateStreams;
